import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import useProjectExportCreate from "~/hooks/useProjectExportCreate";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";
import { ProjectExportCreateForm, ProjectExportCreateFormInput } from "~/shared/components/ProjectExportCreateForm";

export function ClientExportCreateScreen() {
    const { t } = useTranslation("projectExport");
    const navigate = useNavigate();

    const { createProjectExport, error } = useProjectExportCreate();
    const { client } = useRequireCurrentClient();

    const handleSubmit = async (data: ProjectExportCreateFormInput) => {
        await createProjectExport({ ...data, clientId: client.id });
        navigate(`..`);
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("ProjectExportCreateScreen.title")}>
                <ProjectExportCreateForm onSubmit={handleSubmit} error={error} isProjectsSelectable />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
